import type { SnackList, SnackSettings, SnackSettings_SnackSettingsQuery } from "@/lib/gql/__generated__/graphql";

import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { SnackSettingsZodSchemaType } from "./validation-schema";

const _excludeKeys = ["hotelID", "baseDomain"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type DesignSnackSettingsFormModel = AutoGeneratorForFormModel<
	SnackSettingsZodSchemaType, //
	ExcludeKeys,
	QueryData
>;

export type QueryData = undefined;

export type ServerModel = SnackSettings & {
	snackList: SnackList;
	/** 公開設定（スナックの「検索に表示しない」をこのフォームで一緒に保存する） */
	guestPageVisibilitySettings: SnackSettings_SnackSettingsQuery["guestPageVisibilitySettings"];
};
